import type { AppNotification } from '../types/notifications'
import type { WatchlistItem } from '../services/watchlist'

/** Mirrors `NotificationTypes::registry()` subtype labels. */
const SUBTYPE_LABELS: Record<string, string> = {
  company_management: 'Ledelsesskift (direktion)',
  company_board: 'Bestyrelsesskift',
  company_ownership: 'Ejerskab',
  company_auditor: 'Revisor',
  company_status: 'Status (opløsning, fusion, konkurs m.m.)',
  company_new_subsidiary: 'Nye datterselskaber',
  company_name_change: 'Navneskift',
  company_founder: 'Stiftere',
  person_role: 'Når personen ind- eller udtræder af en rolle i et selskab',
  person_new_company: 'Nyt selskab / ny tilknytning',
  person_stake: 'Når personen bliver ejer eller ændrer ejerandel',
}

export function notificationSubtypeLabel(subtype: string): string {
  return SUBTYPE_LABELS[subtype] ?? subtype
}

export function notificationEntityLabel(
  notification: AppNotification,
  watchlistItem?: WatchlistItem
): string {
  if (watchlistItem?.displayName) return watchlistItem.displayName
  if (notification.title) return notification.title
  if (notification.entityId) return notification.entityId
  return notification.entityType === 'person' ? 'denne person' : 'denne virksomhed'
}
